"use client"

import React, { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";

const FAQ = () => {
  const intl = useIntl();

  useEffect(() => {
    document.addEventListener("click", function (e) {
      if (!e.target.matches(".faqs .faq-btn")) return;
      else {
        if (!e.target.parentElement.classList.contains("active")) {
          var elementList = document.querySelectorAll(".faqs .faq");
          Array.prototype.forEach.call(elementList, function (e) {
            e.classList.remove("active");
          });
          e.target.parentElement.classList.add("active");
        } else {
          e.target.parentElement.classList.remove("active");
        }
      }
    });
  }, []);

  return (
    <section id="faq" className="relative z-10 bg-[#F8FAFB] py-[110px] dark:bg-[#15182B]">
      <div className="container">
        <div className="wow fadeInUp mx-auto mb-14 max-w-[690px] text-center lg:mb-[70px]" data-wow-delay=".2s">
          <h2 className="mb-4 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[44px] md:leading-tight">
            <FormattedMessage
              id="home-page-faq-title"
            />
          </h2>
          <p className="text-base text-body">
            <FormattedMessage
              id="home-page-faq-description"
            />
          </p>
        </div>

        <div className="faqs wow fadeInUp mx-auto w-full max-w-[785px] rounded-lg bg-white px-6 py-[6px] shadow-card dark:bg-black dark:shadow-card-dark" data-wow-delay=".3s">
          {(intl.messages["home-page-faq-questions"])?.map((item, index) => (
            <div
              key={index}
              className="border-b faq border-stroke last-of-type:border-none dark:border-stroke-dark"
            >
              <button
                className="faq-btn relative flex w-full justify-between py-6 px-[18px] text-left text-base font-medium text-black dark:text-white sm:px-[26px] sm:text-lg"
              >
                {item?.title}
              </button>
              <div className="faq-content h-auto overflow-hidden border-t border-stroke px-[18px] dark:border-stroke-dark sm:px-[26px]">
                <p className="text-base text-body"
                  dangerouslySetInnerHTML={{
                    __html: item?.description
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;